import User from "../../../dto/User"

export enum ActionType {
    USER_LOADING = 'USER_LOADING',
    USER_LOADED = 'USER_LOADED',
    SHOW_USER_PROFILE = 'SHOW_USER_PROFILE',
}

export interface ActionFetchUserLoaded {
    type: ActionType.USER_LOADED,
    user: User | undefined
}
export interface ActionProfile {
    type: ActionType.SHOW_USER_PROFILE,
    open: boolean
}
type Action = ActionFetchUserLoaded | ActionProfile

export default Action